"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.TabItem = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var TabItem = _styled.default.li(function (_ref) {
  var space = _ref.theme.space,
      fullWidth = _ref.fullWidth,
      isSelected = _ref.isSelected;
  return {
    padding: "".concat(space.medium, " ").concat(space.base),
    cursor: 'pointer',
    transition: 'opacity 300ms',
    borderBottom: isSelected ? '3px solid rgb(0, 0, 0)' : 'unset',
    flexGrow: fullWidth ? 1 : 0,
    '& > *': {
      whiteSpace: 'nowrap',
      fontWeight: isSelected ? 'bold' : 'unset'
    }
  };
});

exports.TabItem = TabItem;
var _default = TabItem;
exports.default = _default;